import { Icon, Title, Tooltip } from '@components/ui';
import { IconsId } from '@types';
import clsx from 'clsx';
import React from 'react';

import styles from './ChartCard.module.scss';

interface ChartCardProps {
  title?: string;
  subtitle?: string;
  icon?: IconsId;
  className?: string;
  iconClassName?: string;
  chartStyle?: React.CSSProperties;
  children: React.ReactNode;
  info?: string;
  infoPosition?: 'top' | 'bottom' | 'left' | 'right';
  onIconClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const ChartCard: React.FC<ChartCardProps> = ({
  className,
  children,
  icon,
  iconClassName,
  chartStyle,
  title,
  subtitle,
  info,
  infoPosition,
  onIconClick,
}) => (
  <div className={clsx(styles.card, className)}>
    <div className={styles.header}>
      {title && (
        <div className={styles.title}>
          <Title
            className={styles.title}
            htmlElement="h3"
          >
            {title}
          </Title>
          {info && (
            <Tooltip
              placement={infoPosition || 'top'}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: info,
                  }}
                />
              }
            >
              <Icon name="question-mark" />
            </Tooltip>
          )}
        </div>
      )}
      {icon && (
        <div className={clsx(styles.iconWrapper, iconClassName)}>
          <Icon
            name={icon}
            onClick={onIconClick}
          />
        </div>
      )}
    </div>
    {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    <div
      className={styles.chart}
      style={chartStyle}
    >
      {children}
    </div>
  </div>
);
